export default __webpack_public_path__ + "static/media/logo_pintar_black.95910400.png";